@if (variant() === 'mobile') {
  <div class="mobile-input-pill">
    <app-icon alt="" [ariaHidden]="true" src="search.svg" [height]="18" [width]="18" className="search-icon" />
    <input
      #searchInput
      type="text"
      role="searchbox"
      class="search-input mobile"
      [placeholder]="placeholder()"
      [value]="query()"
      (input)="onInput($event)"
      autocomplete="off"
      spellcheck="false" />
    @if (query()) {
      <button type="button" class="clear-button mobile" aria-label="Eingabe löschen" (click)="onClear()">
        <app-icon alt="" [ariaHidden]="true" src="x.svg" [height]="13" [width]="13" />
      </button>
    }
  </div>
} @else {
  <div class="desktop-input-row">
    <app-icon alt="" [ariaHidden]="true" src="search.svg" [height]="22" [width]="22" className="search-icon" />
    <input
      #searchInput
      type="text"
      role="searchbox"
      class="search-input"
      [placeholder]="placeholder()"
      [value]="query()"
      (input)="onInput($event)"
      autocomplete="off"
      spellcheck="false" />
    @if (query()) {
      <button type="button" class="clear-button" aria-label="Eingabe löschen" (click)="onClear()">
        <app-icon alt="" [ariaHidden]="true" src="x.svg" [height]="15" [width]="15" />
      </button>
    }
  </div>
}
